import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { Alert, IconButton, Snackbar } from "@mui/material";
import React from "react";

function FeedbackSnackbar({ open, message, severity = "info", onClose, action }) {
  return (
    <Snackbar
      open={open}
      autoHideDuration={5000}
      onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
    >
      <Alert
        onClose={onClose}
        severity={severity}
        variant="filled"
        action={
          <>
            {action}
            <IconButton color="inherit" size="small" onClick={onClose}>
              <CloseRoundedIcon fontSize="small" />
            </IconButton>
          </>
        }
        sx={{ width: "100%", minWidth: 280 }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
}

export default FeedbackSnackbar;
